const professional = {
  root: "professionnel",
  root_plural: "professionnels",
  website: "Site web",
  details: "Détails du professionnel",
  no_hairdresser: "Pas de coiffeur",
};
export default professional;
